import React from 'react';
import '../Layout.css';
import '../Article.css'

export default class Footer extends React.Component {
    render() {
        return (
            <footer className="copyright">
                <small>Copyright &copy; 2021 {this.props.siteAuthor} All rights reserved</small>
            </footer>
        )
    }
}